// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"581":"b1ae206f94090919","658":"8787800d6d22ab9c"}[chunkId] + ".css";
};